var map = {
	"./basement.jpg": "72dc",
	"./castaway.jpg": "283b",
	"./district7.jpg": "2567",
	"./leona.jpg": "f496",
	"./lucas.jpg": "04bd",
	"./sidebyside.jpg": "872c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";